import { Card, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid, CircularProgress, Box } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { getDecryptedAccessToken, getDecryptedData } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../../Utils/ApiServices/ApiServices';
import WaterIntakeAdd from './WaterIntakeAdd';
import { Fastfood, FitnessCenter, LocalDrink, DirectionsWalk } from '@mui/icons-material'; // Add icons

const DailyReportData = () => {
    const accessToken = getDecryptedAccessToken();
    const LoginUserDetails = getDecryptedData();
    const [openDialog, setOpenDialog] = useState(false); // To manage dialog visibility
    const [selectedComponent, setSelectedComponent] = useState(null);
    const [values, setValues] = useState({
        waterIntake: 3,
        waterIntakeDone: 0,
        caloriesIntake: 2000,
        caloriesBurn: 230,
        steps: 3000,
    });

    // Fetch the data when component mounts or state changes
    useEffect(() => {
        fetchDailyGoals();
        fetchWaterIntakeData();
    }, []);

    const fetchDailyGoals = async () => {
        try {
            const response = await ApiServices.get(`/apis/default/portal/dailygoalsetup/${LoginUserDetails?.pid}`, {
                Authorization: `Bearer ${accessToken}`,
            });
            const data = response.data.data || {};
            setValues((prevValues) => ({
                ...prevValues,
                waterIntake: Math.round(data.water_intake_liters) || 3,
                caloriesIntake: Math.round(data.calories_intake) || 2000,
                caloriesBurn: Math.round(data.calories_burn) || 230,
                steps: Math.round(data.steps) || 3000,
            }));
        } catch (error) {
            console.error('Error fetching daily goals:', error);
        }
    };

    const fetchWaterIntakeData = async () => {
        try {
            const currentDate = new Date().toISOString().split('T')[0];
            const response = await ApiServices.get(
                `/apis/default/portal/waterintake?pid=${LoginUserDetails?.pid}&date=${currentDate}`,
                {
                    Authorization: `Bearer ${accessToken}`,
                }
            );
            const intakeData = response.data?.data;
            setValues((prevValues) => ({
                ...prevValues,
                waterIntakeDone: parseFloat(intakeData?.volume) || 0,
            }));
        } catch (error) {
            console.error('Error fetching water intake data:', error);
        }
    };

    const handleOpenDialog = (component) => {
        setSelectedComponent(component);
        setOpenDialog(true); // Open the dialog when a component is selected
    };

    const handleCloseDialog = () => {
        setOpenDialog(false); // Close the dialog
        fetchDailyGoals(); // Refresh data after closing dialog
        fetchWaterIntakeData();
    };

    const data = [
        { id: 1, title: 'Calories Burned', goal: values.caloriesBurn, done: 230, icon: <FitnessCenter />, color: '#FF9800', component: null },
        { id: 2, title: 'Calories Eaten', goal: values.caloriesIntake, done: 2000, icon: <Fastfood />, color: '#FF5722', component: null },
        { id: 3, title: 'Water Intake', goal: values.waterIntake, done: values.waterIntakeDone, icon: <LocalDrink />, color: '#028391', component: WaterIntakeAdd },
        { id: 4, title: 'Today\'s Steps', goal: values.steps, done: 320, icon: <DirectionsWalk />, color: '#8BC34A', component: null },
    ];

    return (
        <div>
            <Typography variant="h5" fontWeight="bold" sx={{ color: '#028391' }}>
                Daily Report
            </Typography>
            <Card
                sx={{
                    p: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2px solid #028391',
                    borderRadius: '12px',
                    minHeight: '300px',
                    gap: 2,
                    boxShadow: 3,
                }}
            >
                <Grid container spacing={4} justifyContent="center">
                    {data.slice(0, 2).map((item) => (
                        <Grid item xs={6} key={item.id} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                           <Button
  onClick={() => item.component && handleOpenDialog(item.component)}
  sx={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  }}
>
  <Box sx={{ position: 'relative', display: 'inline-flex' }}>
    {/* Background track (incomplete portion) */}
    <CircularProgress
      variant="determinate"
      value={100}
      sx={{
        color: '#e0e0e0', // Incomplete ring color
        width: 100,
        height: 100,
      }}
      thickness={5.5}
    />

    {/* Foreground progress (done portion) */}
    <CircularProgress
      variant="determinate"
      value={(item.done / item.goal) * 100}
      sx={{
        color: item.color, // Complete portion color
        position: 'absolute',
        left: 0,
        top: 0,
        width: 100,
        height: 100,
      }}
      thickness={5.5}
    />

    {/* Icon inside the ring */}
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: item.color,
      }}
    >
      {item.icon}
    </Box>
  </Box>

  <Typography variant="body2" sx={{ mt: 1, color: '#333' }}>{item.title}</Typography>
  <Typography variant="body2" sx={{ color: '#666' }}>
    {item.done} / {item.goal}
  </Typography>
</Button>

                        </Grid>
                    ))}
                </Grid>
                <Grid container spacing={4} justifyContent="center">
                    {data.slice(2).map((item) => (
                        <Grid item xs={6} key={item.id} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Button
                                onClick={() => item.component && handleOpenDialog(item.component)} // Only open dialog for components like WaterIntakeAdd
                                sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}
                            >
                                <CircularProgress
                                    variant="determinate"
                                    value={(item.done / item.goal) * 100}
                                    sx={{
                                        color: item.color,
                                        width: 80,
                                        height: 80,
                                        position: 'relative',
                                    }}
                                />
                                <Typography variant="body2" sx={{ mt: 1, color: '#333' }}>{item.title}</Typography>
                                <Typography variant="body2" sx={{ color: '#666' }}>
                                    {item.done} / {item.goal}
                                </Typography>
                                <div style={{ marginTop: '8px', color: item.color }}>{item.icon}</div>
                            </Button>
                        </Grid>
                    ))}
                </Grid>
            </Card>

            {/* Dialog Component */}
            <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Details</DialogTitle>
                <DialogContent>
                    {selectedComponent && React.createElement(selectedComponent, {
                        closeModalAndRefresh: handleCloseDialog,
                        values: values,
                    })}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Close</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DailyReportData;
